import { CSSObjectWithLabel, StylesConfig } from "react-select";

import { greyMui, orangeMui, rydeColors, ScreenDepth } from "@ryde/theme";

const MOBILE_VIEW_DROPDOWN_WIDTH = 320;
const DESKTOP_VIEW_DROPDOWN_WIDTH = 400;
const VIEW_BLANKET_BORDER = 1;

export const viewDropdownSelectStyles = (
  isMobile?: boolean,
): StylesConfig<unknown, false> => ({
  control: provided =>
    ({
      ...provided,
      position: "absolute",
      width: isMobile
        ? MOBILE_VIEW_DROPDOWN_WIDTH + VIEW_BLANKET_BORDER
        : DESKTOP_VIEW_DROPDOWN_WIDTH + VIEW_BLANKET_BORDER,
      top: 8,
      insetInlineEnd: 0,
      height: 40,
      zIndex: ScreenDepth.HEADER_FORM_CONTROLS,
      borderColor: greyMui._200,
      boxShadow: "none",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      paddingInlineStart: 10,
      ":hover": {
        borderColor: greyMui._200,
      },
    }) as CSSObjectWithLabel,
  menu: provided =>
    ({
      ...provided,
      borderRadius: 4,
      position: "absolute",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      zIndex: ScreenDepth.HEADER_FORM_CONTROLS,
      margin: 0,
      top: 49,
      insetInlineEnd: 0,
      width: isMobile
        ? MOBILE_VIEW_DROPDOWN_WIDTH
        : DESKTOP_VIEW_DROPDOWN_WIDTH,
    }) as CSSObjectWithLabel,
  menuList: provided =>
    ({
      ...provided,
      padding: 0,
      marginTop: "-1px",
    }) as CSSObjectWithLabel,
  option: provided =>
    ({
      ...provided,
      backgroundColor: rydeColors.white,
      color: rydeColors.black,
      ":hover": {
        backgroundColor: greyMui._200,
      },
      " .active_view": {
        backgroundColor: orangeMui._200,
      },
    }) as CSSObjectWithLabel,
  input: provided =>
    ({
      ...provided,
      ":hover": {
        border: "none",
      },
    }) as CSSObjectWithLabel,
});
